(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/rules/assets/javascripts/utils/lotto-utils.js') >= 0) return;  svs.modules.push('/components/numbergames/rules/assets/javascripts/utils/lotto-utils.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

let config;
let productMapping;
let currencyAsJupiterString;
if (svs.isServer) {
  var _trinidadCore$config$;
  const trinidadCore = require('trinidad-core').core;
  ({
    productMapping
  } = trinidadCore.components.require('numbergames', 'product-mapping'));
  currencyAsJupiterString = trinidadCore.components.require('utils', 'format').CurrencyAsJupiterString;
  config = (_trinidadCore$config$ = trinidadCore.config.options.cms) === null || _trinidadCore$config$ === void 0 ? void 0 : _trinidadCore$config$.numbergames;
} else {
  var _svs$numbergames$rule;
  ({
    productMapping
  } = svs.numbergames);
  currencyAsJupiterString = svs.utils.format.CurrencyAsJupiterString;
  config = (_svs$numbergames$rule = svs.numbergames.rules.data) === null || _svs$numbergames$rule === void 0 ? void 0 : _svs$numbergames$rule.config;
}
const isNewRules = _ref => {
  var _config$lotto$ruleCha, _config;
  let {
    drawNumber,
    product
  } = _ref;
  if (!drawNumber || !product) {
    return false;
  }
  const {
    ONSLOTTO,
    LORLOTTO
  } = (_config$lotto$ruleCha = (_config = config) === null || _config === void 0 || (_config = _config.lotto) === null || _config === void 0 ? void 0 : _config.ruleChange) !== null && _config$lotto$ruleCha !== void 0 ? _config$lotto$ruleCha : {};
  if (!ONSLOTTO || !LORLOTTO) {
    return false;
  }
  switch (true) {
    case productMapping.isLottoWednesday(product) && drawNumber >= ONSLOTTO:
    case productMapping.isLottoSaturday(product) && drawNumber >= LORLOTTO:
      return true;
    default:
      return false;
  }
};
const getRuleChangeDrawNumber = product => {
  var _config$lotto$ruleCha2, _config2;
  const {
    ONSLOTTO,
    LORLOTTO
  } = (_config$lotto$ruleCha2 = (_config2 = config) === null || _config2 === void 0 || (_config2 = _config2.lotto) === null || _config2 === void 0 ? void 0 : _config2.ruleChange) !== null && _config$lotto$ruleCha2 !== void 0 ? _config$lotto$ruleCha2 : {};
  switch (true) {
    case productMapping.isLottoWednesday(product):
      return ONSLOTTO;
    case productMapping.isLottoSaturday(product):
      return LORLOTTO;
    default:
      svs.numbergames.rules.logger.debug('getRuleChangeDrawNumber: missing params');
  }
};
const getIsRuleChangePeriod = _ref2 => {
  var _config$lotto$ruleCha3, _config3;
  let {
    firstDraw,
    lastDraw,
    product
  } = _ref2;
  const {
    ONSLOTTO,
    LORLOTTO
  } = (_config$lotto$ruleCha3 = (_config3 = config) === null || _config3 === void 0 || (_config3 = _config3.lotto) === null || _config3 === void 0 ? void 0 : _config3.ruleChange) !== null && _config$lotto$ruleCha3 !== void 0 ? _config$lotto$ruleCha3 : {};
  if (!firstDraw || !lastDraw || !product || !ONSLOTTO || !LORLOTTO) {
    svs.numbergames.rules.logger.debug('isRuleChangePeriod: missing params');
    return false;
  }
  switch (true) {
    case productMapping.isLottoWednesday(product) && firstDraw < ONSLOTTO && lastDraw >= ONSLOTTO:
    case productMapping.isLottoSaturday(product) && firstDraw < LORLOTTO && lastDraw >= LORLOTTO:
      return true;
    default:
      return false;
  }
};
function showRuleChangeInfo(_ref3) {
  let {
    firstDraw,
    lastDraw,
    product,
    numDrawsOverChange = 10
  } = _ref3;
  const ruleChangeDrawNum = getRuleChangeDrawNumber(product);
  const isRuleChangePeriod = getIsRuleChangePeriod({
    firstDraw,
    lastDraw,
    product
  });
  return firstDraw >= ruleChangeDrawNum && firstDraw <= ruleChangeDrawNum + numDrawsOverChange || isRuleChangePeriod;
}
function calcNumNewRuleDraws(drawNumber, drawCount, ruleChangeDraw) {
  if (!drawNumber || !drawCount || !ruleChangeDraw) {
    return 0;
  }
  const lastDraw = drawNumber + (drawCount - 1);
  if (lastDraw < ruleChangeDraw) {
    return 0;
  }
  if (drawNumber >= ruleChangeDraw) {
    return drawCount;
  }
  return drawCount - (ruleChangeDraw - drawNumber);
}
function toApiWagersLottoNewRules(_ref4) {
  let {
    wagers,
    product,
    next
  } = _ref4;
  if (!productMapping.isLotto(product)) {
    return next({
      wagers
    });
  }
  const getRowCount = bet => {
    if (productMapping.isLotto(bet.productId)) {
      return bet.lottoBoards.reduce((acc, board) => acc + svs.numbergames.rules.system.generatedRows({
        numbersLength: board.boardData.length,
        numbersRowSize: svs.numbergames.rules.getRules('lotto').numbersMaxLength
      }), 0);
    }
  };
  const getBetAmounts = bet => {
    let betAmountSalesGroup1 = bet.betAmountSalesGroup1;
    let betAmountSalesGroup2 = bet.betAmountSalesGroup2;
    if (productMapping.isLotto(bet.productId)) {
      const rowPrice = svs.numbergames.rules.getRules(bet.productId, {
        product: bet.productId,
        drawNumber: bet.drawNum
      }).rowPrice;
      betAmountSalesGroup1 = currencyAsJupiterString(rowPrice * getRowCount(bet) * bet.numDraws);
      if (parseInt(betAmountSalesGroup2, 10) > 0) {
        betAmountSalesGroup2 = betAmountSalesGroup1;
      }
    }
    if (productMapping.isJoker(bet.productId) && bet.originalNumDraws) {
      betAmountSalesGroup1 = currencyAsJupiterString(parseInt(betAmountSalesGroup1, 10) / bet.originalNumDraws * bet.numDraws);
    }
    return {
      betAmountSalesGroup1,
      betAmountSalesGroup2
    };
  };
  const apiWagers = [];
  wagers.forEach(wager => {
    const lottoBet = wager.bets.find(b => productMapping.isLotto(b.productId));
    const ruleChangeDrawNumber = getRuleChangeDrawNumber(lottoBet.productId);
    const numNewRuleDraws = calcNumNewRuleDraws(lottoBet.drawNum, lottoBet.numDraws, ruleChangeDrawNumber);
    const originalNumDraws = lottoBet.numDraws;
    if (!numNewRuleDraws) {
      apiWagers.push(wager);
    } else if (numNewRuleDraws < originalNumDraws) {
      const wagerCopy = _objectSpread(_objectSpread({}, JSON.parse(JSON.stringify(wager))), {}, {
        isNewRules: true
      });
      wager.bets.forEach(bet => {
        if (productMapping.isLotto(bet.productId)) {
          bet.betProperties.push('FIRST_SPLIT_WAGER');
        }
        bet.numDraws -= numNewRuleDraws;
        bet.originalNumDraws = originalNumDraws;
        ({
          betAmountSalesGroup1: bet.betAmountSalesGroup1,
          betAmountSalesGroup2: bet.betAmountSalesGroup2
        } = getBetAmounts(bet));
      });
      wagerCopy.bets.forEach(bet => {
        bet.numDraws = numNewRuleDraws;
        bet.originalNumDraws = originalNumDraws;
        bet.drawNum += ruleChangeDrawNumber - lottoBet.drawNum;
        ({
          betAmountSalesGroup1: bet.betAmountSalesGroup1,
          betAmountSalesGroup2: bet.betAmountSalesGroup2
        } = getBetAmounts(bet));
      });
      apiWagers.push(wager, wagerCopy);
    } else if (numNewRuleDraws === originalNumDraws) {
      wager.bets.forEach(bet => {
        ({
          betAmountSalesGroup1: bet.betAmountSalesGroup1,
          betAmountSalesGroup2: bet.betAmountSalesGroup2
        } = getBetAmounts(bet));
      });
      apiWagers.push(wager);
    }
  });
  next({
    wagers: apiWagers
  });
}
if (svs.isServer) {
  module.exports = {
    isNewRules,
    getIsRuleChangePeriod,
    toApiWagersLottoNewRules,
    showRuleChangeInfo,
    calcNumNewRuleDraws,
    getRuleChangeDrawNumber
  };
} else {
  Object.assign(svs.numbergames.rules.utils.lotto, {
    isNewRules,
    getIsRuleChangePeriod,
    toApiWagersLottoNewRules,
    showRuleChangeInfo,
    calcNumNewRuleDraws,
    getRuleChangeDrawNumber
  });
}

 })(window);